<template>
  <div class="row">
    <loading
      class="custom-loading-overlay"
      :active="isLoading"
      :color="loadingColor"
      :isFullPage="true"
    ></loading>
    <div class="col-12" style="padding-left: 5px; padding-right: 5px">
      <div
        class="card card-style"
        style="background-color: white; margin-left: 0px; margin-right: 0px"
      >
        <div class="card-body text-center" id="card-geral">
          <div class="form-group mb-3">
            <h5 class="card-title">SOLICITAR ATENDIMENTO</h5>
          </div>
          <div
            class="d-flex justify-content-center align-items center mb-5"
            v-if="personSelected == false"
          >
            <section v-if="consent.status == false">
              <div class="row">
                <div class="col-12" style="font-weight: bold">
                  TERMOS E CONDIÇÕES GERAIS DE USO DO APLICATIVO SAMU DIGITAL
                </div>

                <div class="col-12 mt-3" style="text-align: left">
                  Estes termos e condições gerais de uso aplicam-se às
                  atividades relativas ao aplicativo denominado SAMU DIGITAL,
                  desenvolvido pela empresa Tec Information Soluções em
                  Informatica LTDA., registrada sob o CNPJ nº
                  29.355.060/0001-09, com sede na Avenida Ibirapuera nº 2907,
                  cj. 601, na cidade de São Paulo/SP. Neste documento, a empresa
                  é designada IT4D. O aplicativo SAMU DIGITAL foi desenvolvido
                  com o intuito de disponibilizar a comunicação, de forma ágil e
                  segura, entre usuários necessitados dos serviços prestados
                  pelo SAMU. Para ter acesso aos serviços disponibilizados pelo
                  aplicativo SAMU DIGITAL, os usuários devem tomar conhecimento
                  das regras que compõem o presente instrumento, as quais
                  ficarão disponíveis para consulta no menu “Sobre”, dentro do
                  próprio aplicativo. Ao fazer uso do aplicativo SAMU DIGITAL, o
                  usuário aceita integralmente o presente termo e compromete-se
                  a observar as normas aqui descritas, sob risco de aplicação
                  das penalidades cabíveis. Caso não concorde com quaisquer das
                  regras aqui descritas, o usuário deve, imediatamente,
                  abster-se de utilizar o serviço. Se for de seu interesse,
                  poderá entrar em contato com o serviço de atendimento ao
                  cliente para apresentar suas ressalvas.

                  <br />
                  <br />
                  1. FUNCIONAMENTO DO APLICATIVO O SAMU DIGITAL é um aplicativo
                  desenvolvido para permitir que o usuário efetue chamadas de
                  urgência e emergência para o SAMU, por meio de redes Wi-Fi ou
                  quaisquer conexões de dados disponíveis, incluindo 3G, 4G e
                  5G. O aplicativo busca garantir que a população possa
                  solicitar ajuda do SAMU em situações críticas. O aplicativo
                  compreende a solicitação, atendimento de chamadas e
                  acompanhamento do resgate em andamento. O aplicativo utilizará
                  o sistema de posicionamento global (GPS) para obter a
                  localização atual do usuário e direcionar a chamada para o
                  SAMU 192. Além disso, a localização do usuário, no momento da
                  realização da chamada, será enviada automaticamente para o
                  SAMU 192. Caso ocorra falha na obtenção da localização via
                  GPS, o usuário poderá cadastrar previamente o município em que
                  se encontra. O aplicativo possibilita que o usuário realize o
                  rastreamento da ambulância destinada à sua ocorrência, sendo
                  informado sobre o tempo de duração da chegada da ambulância
                  até o local informado. O aplicativo pode ser utilizado tanto
                  pela vítima quanto pelo socorrente, desde que o socorrente
                  tenha cadastro no aplicativo e utilize seu próprio login e
                  senha. Ao clicar no aplicativo na opção “Chamar SAMU”, o
                  usuário irá se identificar como vítima ou socorrente, devendo
                  informar os dados pessoais solicitados, se for o caso. Para
                  maiores detalhes sobre os dados pessoais coletados, consulte
                  nossa Política de Privacidade. O aplicativo foi desenvolvido
                  com o objetivo de contribuir para a segurança e bem-estar da
                  população, fornecendo uma solução alternativa de comunicação
                  em situações de emergência.
                  <br />
                  <br />
                  2. DISPONIBILIDADE GEOGRÁFICA O aplicativo SAMU DIGITAL está
                  disponível em algumas regiões do Brasil. Para consultar se a
                  sua cidade possui cobertura, acesse: <br />
                  <br />3. ADIÇÃO E REMOÇÃO DE MUNICÍPIOS O aplicativo SAMU
                  DIGITAL poderá ter novos municípios adicionados para
                  atendimento ou municípios existentes removidos sem prévio
                  aviso. A inclusão de novos municípios será realizada com base
                  na expansão dos serviços oferecidos pela IT4D ao SAMU 192 e na
                  demanda identificada para atender a novas localidades. Caso a
                  IT4D identifique a necessidade de remover municípios do
                  aplicativo, tal ação poderá ser realizada sem prévio aviso,
                  visando garantir a atualidade e eficiência do aviso.<br />
                  <br />4. CADASTRO DO USUÁRIO Para utilizar o aplicativo SAMU
                  DIGITAL, o usuário deverá realizar cadastro fornecendo as
                  seguintes informações: nome, CPF, e-mail, telefone, foto
                  segurando o documento de identidade. O usuário declara e
                  garante que todas as informações fornecidas no cadastro são
                  verdadeiras, precisas e atualizadas. O aplicativo não se
                  responsabiliza por dados cadastrais incorretos ou
                  desatualizados. O número de telefone informado pelo usuário
                  precisará ser validado por meio de um código enviado via SMS.
                  É essencial que o usuário possua sinal de operadora móvel no
                  momento do cadastro, caso contrário, a validação não será
                  possível de ser realizada. Essa verificação é importante para
                  garantir que o número fornecido no cadastro seja real e de
                  propriedade do usuário. A IT4D se compromete a utilizar os
                  dados cadastrais do usuário em conformidade com a legislação
                  aplicável, em especial a LGPD.<br />
                  <br />
                  5. RESPONSABILIDADE DA CONEXÃO DE INTERNET E QUALIDADE DA
                  CHAMADA A IT4D não se responsabiliza pela qualidade,
                  estabilidade ou disponibilidade da conexão de internet
                  utilizada pelo usuário para efetuar chamadas. É de
                  responsabilidade exclusiva do usuário garantir que seu
                  dispositivo móvel ou outro dispositivo utilizado para acessar
                  o aplicativo SAMU DIGITAL esteja conectado a uma rede Wi-Fi ou
                  tenha acesso a conexão de dados móveis. O usuário reconhece
                  que a utilização do aplicativo está sujeita a eventuais
                  problemas de conexão, podendo ocorrer interrupções temporárias
                  nas chamadas ou dificuldades de comunicação em áreas com
                  cobertura limitada. A IT4D empregará esforços para manter o
                  aplicativo e suas funcionalidades em pleno funcionamento,
                  contudo, não pode garantir a disponibilidade ininterrupta do
                  serviço em todas as situações. O usuário reconhece que a
                  qualidade da conexão de internet utilizada para efetuar a
                  chamada pode influenciar na eficácia e estabilidade da
                  ligação. O aplicativo funcionará apenas se estiver
                  “conectado”. Caso esteja “desconectado”, o usuário deverá
                  verificar sua conexão com a internet antes de tentar realizar
                  a chamada. Em caso de falhas durante uma chamada, a IT4D
                  recomenda que o usuário verifique sua conexão de internet e
                  tente realizar uma nova chamada em seguida. <br />
                  <br />6. MAU USO E TROTES O usuário está ciente de que o mau
                  uso do aplicativo SAMU DIGITAL ou a realização de trotes, ou
                  seja, chamadas falsas para o SAMU 192, é uma prática ilegal e
                  sujeita a punições de acordo com a legislação brasileira. O
                  usuário que incorrer em tais comportamentos poderá ser
                  responsabilizado e responderá por seus atos perante a lei.<br />
                  <br />
                  7. LIMITAÇÃO DE RESPONSABILIDADE A IT4D não oferece garantias
                  de que o aplicativo SAMU DIGITAL atenderá às necessidades
                  específicas do usuário ou estará livre de erros ou falhas. A
                  IT4D não se responsabiliza por quaisquer danos, prejuízos ou
                  perdas, diretos ou indiretos, decorrentes do uso do
                  aplicativo, incluindo, mas não se limitando a: interrupção da
                  transmissão de dados, perda de informações, falhas técnicas ou
                  qualquer outra circunstância alheia ao controle da IT4D. O
                  aplicativo é disponibilizado para uso exclusivo como uma
                  ferramenta adicional para acionamento do SAMU 192, e a ITD4
                  não se responsabiliza por qualquer consequência decorrente do
                  uso inadequado, negligente ou malicioso do aplicativo pelo
                  usuário. No entanto, a IT4D se responsabilizará pelos defeitos
                  ou vícios encontrados nos serviços prestados pelo aplicativo,
                  desde que a causa do defeito e/ou vício tenha sido provocada
                  por ela. Defeitos ou vícios técnicos ou operacionais
                  originados pelo próprio sistema do usuário não serão de
                  responsabilidade da IT4D.<br />
                  <br />
                  8. RESPONSABILIDADES DO USUÁRIO O usuário é responsável por
                  manter a confidencialidade de seus dados de acesso ao
                  aplicativo e por garantir que suas informações fornecidas no
                  cadastro sejam precisas e atualizadas. O usuário deverá
                  utilizar o aplicativo de forma ética, responsável e em
                  conformidade com a legislação aplicável, abstendo-se de
                  realizar qualquer atividade que possa comprometer o
                  funcionamento ou segurança do aplicativo SAMU DIGITAL. O
                  usuário é responsável por qualquer dano ou prejuízo causado
                  pelo uso indevido do aplicativo.<br />
                  <br />
                  9. PRIVACIDADE E PROTEÇÃO DE DADOS PESSOAIS Os dados pessoais
                  são coletados e tratados conforme descrito na Política de
                  Privacidade, sendo eles: nome, CPF, e-mail, telefone, data de
                  nascimento, telefone, sexo, CEP, endereço completo, estado,
                  cidade, posição do GPS e demais informações relacionadas à
                  saúde. As informações serão armazenadas de forma segura e
                  protegida, sendo retidas pelo tempo necessário para cumprir os
                  fins para os quais foram coletadas. A ITD4 não compartilhará
                  as informações pessoais do usuário com terceiros, exceto
                  quando necessário para a prestação dos serviços do aplicativo;
                  atender a solicitações legais ou proteger seus direitos,
                  propriedade ou segurança. A ITD4 adota medidas de segurança
                  adequadas para proteger as informações, mas não pode garantir
                  a segurança absoluta delas.<br />
                  <br />
                  10. DIREITOS AUTORAIS O aplicativo SAMU DIGITAL, juntamente
                  com todos os seus conteúdos, logotipos, marcas registradas e
                  demais elementos relacionados, são protegidos por leis
                  brasileiras de direitos autorais e propriedade intelectual.
                  Todos os direitos autorais e de propriedade intelectual
                  relacionados ao aplicativo são e permanecerão de propriedade
                  exclusiva da ITD4 ou de seus licenciadores. Fica estritamente
                  proibida a reprodução, distribuição, cópia, modificação,
                  engenharia reversa ou qualquer outra forma de utilização não
                  autorizada pelo aplicativo, total ou parcial, em qualquer
                  meio, sem a expressa autorização prévia e por escrito da ITD4.
                  Essa proibição inclui a criação de trabalhos derivados ou
                  adaptações do aplicativo sem autorização. Os usuários do
                  aplicativo têm permissão para utilizar o software de acordo
                  com as finalidades e funcionalidades disponibilizadas pela
                  ITD4. Qualquer uso fora do escopo das finalidades autorizadas
                  é estritamente proibido. Todos os direitos não expressamente
                  concedidos aos usuários por meio destes Termo de Uso são
                  reservados à ITD4. Nenhuma disposição neste documento deve ser
                  interpretada como concessão implícita ou renúncia a quaisquer
                  direitos de propriedade intelectual ou direitos autorais
                  detidos pela ITD4.<br />
                  <br />
                  11. SUSPENSÃO, ENCERRAMENTO E ATUALIZAÇÃO DO APLICATIVO A ITD4
                  reserva-se no direito de suspender, encerrar ou realizar
                  atualizações no aplicativo SAMU DIGITAL a qualquer momento,
                  sem prévio aviso aos usuários. A suspensão ou encerramento do
                  aplicativo poderá ocorrer por decisão da empresa, em casos de
                  descumprimento deste Termo pelo usuário, falhas técnicas,
                  atualizações de segurança, ou outras situações que justifiquem
                  a interrupção do serviço. Caso haja atualização do aplicativo,
                  a ITD4 se esforçará para informar os usuários sobre as
                  alterações e melhorias implementadas. Em caso de suspensão ou
                  encerramento do acesso, o usuário não terá direito a qualquer
                  indenização ou compensação.<br />
                  <br />
                  12. DÚVIDAS E SUGESTÕES Para esclarecer dúvidas, enviar
                  sugestões ou relatar problemas relacionados ao aplicativo SAMU
                  DIGITAL, o usuário poderá entrar em contato por meio do
                  e-mail.<br />
                  <br />
                  13. ALTERAÇÃO DESTE TERMO A ITD4 poderá alterar os termos
                  deste documento a qualquer momento, e as alterações serão
                  consideradas vigentes a partir do momento em que forem
                  disponibilizadas no aplicativo. É responsabilidade do usuário
                  verificar periodicamente os Termos de Uso para estar ciente de
                  eventuais atualizações.<br />
                  <br />
                  14. DISPOSIÇÕES GERAIS A ITD4 não será responsável por
                  qualquer indisponibilidade ou falha do aplicativo SAMU DIGITAL
                  decorrente de problemas técnicos de responsabilidade das
                  operadoras de telefonia móvel, provedores de internet ou de
                  terceiros. O usuário reconhece que o aplicativo poderá estar
                  sujeito a limitações técnicas e operacionais, não sendo
                  garantido o funcionamento ininterrupto ou livre de erros. O
                  usuário compromete-se a utilizar o aplicativo de forma ética e
                  responsável, abstendo-se de utilizar meios técnicos ou
                  dispositivos para interferir no funcionamento do aplicativo ou
                  no acesso de outros usuários. Caso alguma disposição deste
                  Termo seja considerada inválida, ilegal ou inexequível, as
                  demais disposições permanecerão em pleno vigor e efeito. A
                  falha da ITD4 em exercer ou fazer cumprir qualquer direito ou
                  disposição deste Termo não constituirá renúncia a tal direito
                  ou disposição.<br />
                  <br />
                  15. FORO Fica eleito o foro da cidade de São Paulo/SP como
                  competente para dirimir quaisquer questões oriundas deste
                  Termo de Uso, com exclusão de qualquer outro, por mais
                  privilegiado que seja.
                  <br />
                  <br />
                  Última atualização: 12.03.2025
                </div>

                <div class="col-12 mt-4">
                  <div class="row">
                    <div class="col-6">
                      <button
                        class="btn btn-block btn-success"
                        @click="setConsent(true)"
                      >
                        Aceitar
                      </button>
                    </div>
                    <div class="col-6">
                      <button
                        class="btn btn-block btn-danger"
                        @click="setConsent(false)"
                      >
                        Rejeitar
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section v-else>
              <div class="row">
                <div class="col-12 mb-2">
                  <h5
                    style="text-align: center; font-size: 17px; margin-bottom: 20px"
                  >
                    PARA QUEM VOCÊ ESTÁ SOLICITANDO ESTE ATENDIMENTO?
                  </h5>
                </div>
                <div class="col-12 mt-3">
                  <button
                    class="btnn"
                    @click="atendimento(1)"
                    id="eu"
                    style="height: 140px; display: flex; align-items: center; justify-content: center; text-align: center; line-height: 1.4;"
                  >
                    <span style="font-size: 16px;">
                      <i
                        class="bi bi-person-check"
                        style="font-size: 54px; display: block; margin-bottom: 6px;"
                      ></i>
                      Preciso de um atendimento para mim
                    </span>
                  </button>
                </div>
                <div class="col-12 mt-3">
                  <button
                    class="btnn"
                    @click="atendimento(0)"
                    id="outro"
                    style="height: 140px; display: flex; align-items: center; justify-content: center; text-align: center; line-height: 1.4;"
                  >
                    <span style="font-size: 16px;">
                      <i
                        class="bi bi-people"
                        style="font-size: 54px; display: block; margin-bottom: 6px;"
                      ></i>
                      Preciso de um atendimento para outra pessoa
                    </span>
                  </button>
                </div>
                <!-- <div class="col-12 mt-3" v-if="locationError">
                  <div class="alert alert-danger d-flex align-items-center">
                    <i
                      class="fas fa-exclamation-circle mr-2"
                      style="font-size: 24px; color: red"
                    ></i>
                    <span>Ative sua localização para continuar.</span>
                  </div>
                </div> -->
              </div>
            </section>
          </div>

          <div class="form-group" v-if="personSelected">
            <!-- Solicitante header -->
            <div
              class="d-flex justify-content-between align-items-center mb-3 px-1 pb-2 wizard-header-strip"
            >
              <span class="wizard-user-name">{{ user.usuario_nome }}</span>
              <span class="wizard-user-phone">{{ paciente.telefone }}</span>
            </div>

            <!-- Step indicator -->
            <div class="wizard-indicator d-flex align-items-center mb-3">
              <div class="wizard-step-item">
                <div
                  class="wizard-step-circle"
                  :class="{ 'wizard-step-active': currentStep >= 1 }"
                >
                  <i class="bi bi-geo-alt-fill"></i>
                </div>
                <div
                  class="wizard-step-label"
                  :class="{ 'wizard-step-label-active': currentStep === 1 }"
                >
                  Endereço
                </div>
              </div>
              <div
                class="wizard-step-line flex-grow-1"
                :class="{ 'wizard-line-done': currentStep > 1 }"
              ></div>
              <div class="wizard-step-item">
                <div
                  class="wizard-step-circle"
                  :class="{ 'wizard-step-active': currentStep >= 2 }"
                >
                  <i class="bi bi-person-fill"></i>
                </div>
                <div
                  class="wizard-step-label"
                  :class="{ 'wizard-step-label-active': currentStep === 2 }"
                >
                  Vítima
                </div>
              </div>
              <div
                class="wizard-step-line flex-grow-1"
                :class="{ 'wizard-line-done': currentStep > 2 }"
              ></div>
              <div class="wizard-step-item">
                <div
                  class="wizard-step-circle"
                  :class="{ 'wizard-step-active': currentStep >= 3 }"
                >
                  <i class="bi bi-clipboard2-pulse-fill"></i>
                </div>
                <div
                  class="wizard-step-label"
                  :class="{ 'wizard-step-label-active': currentStep === 3 }"
                >
                  Ocorrência
                </div>
              </div>
            </div>

            <!-- ======== ETAPA 1: Endereço ======== -->
            <div v-show="currentStep === 1">
              <div class="row">
                <!-- Atalhos de endereço -->
                <div class="col-6 pr-1">
                  <button class="btn-gps btn-sm mb-3" @click="myAddress()">
                    <i class="bi bi-house-fill"></i> Endereço cadastrado
                  </button>
                </div>
                <div class="col-6 pl-1">
                  <button
                    class="btn-gps btn-sm mb-3"
                    :disabled="locationError"
                    @click="getGeo()"
                  >
                    <i class="bi bi-crosshair2"></i> Localização atual
                  </button>
                </div>

                <!-- Endereço confirmado: exibe card resumo + edição de número/complemento -->
                <template v-if="addressConfirmed">
                  <div class="col-12">
                    <div class="address-confirmed-card">
                      <div class="address-confirmed-icon">
                        <i class="bi bi-geo-alt-fill"></i>
                      </div>
                      <div class="address-confirmed-info">
                        <div class="address-confirmed-main">
                          {{ ocorrencia.logradouro }}
                        </div>
                        <div class="address-confirmed-sub">
                          {{ ocorrencia.bairro ? ocorrencia.bairro + " · " : ""
                          }}{{ ocorrencia.cidade }} - {{ ocorrencia.uf }}
                        </div>
                      </div>
                      <button
                        class="address-confirmed-change"
                        @click="clearAddress()"
                      >
                        alterar
                      </button>
                    </div>
                  </div>
                  <div class="col-6 mt-2 pr-1">
                    <input
                      id="inputNumero"
                      placeholder="Número"
                      type="text"
                      class="form-control"
                      v-model="ocorrencia.numero"
                      maxlength="10"
                      @input="sanitizeNumero"
                      v-on:input="scheduleLatLngLookup()"
                    />
                  </div>
                  <div class="col-6 mt-2 pl-1">
                    <input
                      placeholder="Complemento"
                      type="text"
                      class="form-control"
                      v-model="ocorrencia.complemento"
                      maxlength="50"
                    />
                  </div>
                </template>

                <!-- Busca por autocomplete -->
                <div class="col-12" v-else>
                  <div class="places-search-wrapper">
                    <i class="bi bi-search places-search-icon"></i>
                    <GmapAutocomplete
                      :key="autocompleteKey"
                      ref="placesInput"
                      :options="{
                        types: ['address'],
                        componentRestrictions: { country: 'br' },
                        fields: [
                          'address_components',
                          'geometry',
                          'formatted_address'
                        ]
                      }"
                      @place_changed="onPlaceChanged"
                      class="form-control places-input"
                      placeholder="Digite o endereço ou local..."
                    />
                  </div>
                </div>

                <!-- Mapa (aparece após endereço confirmado) -->
                <div
                  class="col-12 mt-3"
                  v-if="mapLoaded && ocorrencia.latitude !== 0"
                >
                  <GmapMap
                    :center="{
                      lat: ocorrencia.latitude,
                      lng: ocorrencia.longitude
                    }"
                    :options="{
                      zoomControl: false,
                      streetViewControl: false,
                      mapTypeControl: false,
                      fullscreenControl: false
                    }"
                    :zoom="16"
                    map-type-id="roadmap"
                    style="width: 100%; height: 200px; border-radius: 16px;"
                    class="mb-3"
                  >
                    <GmapMarker :position="position"></GmapMarker>
                  </GmapMap>
                </div>
              </div>
              <div class="col-12 mt-2 px-0">
                <button class="btnn" @click="currentStep = 2">
                  Próximo <i class="bi bi-arrow-right"></i>
                </button>
              </div>
            </div>

            <!-- ======== ETAPA 2: Vítima ======== -->
            <div v-show="currentStep === 2">
              <!-- Toggle não identificado (só para "outro") -->
              <div
                class="vitima-unidentified-toggle"
                v-if="typePerson == 2"
                @click="nao_identificado = !nao_identificado"
              >
                <div class="vitima-unidentified-text">
                  <i class="bi bi-question-circle"></i>
                  Vítima não identificada
                </div>
                <toggle-button
                  :labels="{ checked: 'Sim', unchecked: 'Não' }"
                  :width="55"
                  v-model="nao_identificado"
                  @click.native.stop
                />
              </div>

              <div class="row mt-2">
                <!-- Nome / Aparência -->
                <div class="col-12 mb-3">
                  <div class="float-label-group">
                    <input
                      type="text"
                      class="form-control float-label-input"
                      id="nome_vitima"
                      v-model="ocorrencia.nome_vitima"
                      :disabled="typePerson == 1"
                      placeholder=" "
                    />
                    <label for="nome_vitima">
                      {{
                        nao_identificado
                          ? "Aparência aproximada"
                          : "Nome completo da vítima"
                      }}
                    </label>
                  </div>
                </div>

                <!-- Identificado: data nasc + telefone + sexo -->
                <template v-if="!nao_identificado">
                  <div class="col-12 mb-3">
                    <div class="float-label-group">
                      <input
                        type="date"
                        class="form-control float-label-input"
                        id="data_nasc"
                        v-model="ocorrencia.data_nascimento_vitima"
                        :disabled="typePerson == 1"
                        min="1900-01-01"
                        max="2100-12-31"
                        placeholder=" "
                      />
                      <label for="data_nasc">Data de nascimento</label>
                    </div>
                    <span
                      v-if="ocorrencia.data_nascimento_vitima"
                      class="vitima-idade-badge"
                    >
                      {{ diffIdade }}
                    </span>
                  </div>

                  <!-- Sexo — linha própria, dois botões largos -->
                  <div class="col-12 mb-3">
                    <div class="sexo-label">Sexo biológico</div>
                    <div
                      class="sexo-btn-group"
                      :class="{ 'sexo-disabled': typePerson == 1 }"
                    >
                      <button
                        type="button"
                        class="sexo-btn"
                        :class="{
                          'sexo-btn-active': ocorrencia.sexo_vitima === 'M'
                        }"
                        :disabled="typePerson == 1"
                        @click="ocorrencia.sexo_vitima = 'M'"
                      >
                        <i class="bi bi-gender-male"></i> Masculino
                      </button>
                      <button
                        type="button"
                        class="sexo-btn"
                        :class="{
                          'sexo-btn-active': ocorrencia.sexo_vitima === 'F'
                        }"
                        :disabled="typePerson == 1"
                        @click="ocorrencia.sexo_vitima = 'F'"
                      >
                        <i class="bi bi-gender-female"></i> Feminino
                      </button>
                    </div>
                  </div>

                  <div class="col-12 mb-3">
                    <div class="float-label-group">
                      <input
                        type="tel"
                        class="form-control float-label-input"
                        id="telefone_vitima"
                        v-model="ocorrencia.telefone"
                        :disabled="typePerson == 1"
                        v-mask="'(99) 99999-9999'"
                        placeholder=" "
                      />
                      <label for="telefone_vitima">Telefone de contato</label>
                    </div>
                  </div>
                </template>

                <!-- Não identificado: idade aparente + sexo + telefone -->
                <template v-else>
                  <div class="col-12 mb-3">
                    <div class="float-label-group">
                      <input
                        type="text"
                        class="form-control float-label-input"
                        id="idade_aparente"
                        v-model="ocorrencia.idade_vitima"
                        maxlength="3"
                        @input="validarIdade"
                        placeholder=" "
                      />
                      <label for="idade_aparente">Idade aparente (anos)</label>
                    </div>
                  </div>

                  <div class="col-12 mb-3">
                    <div class="sexo-label">Sexo biológico</div>
                    <div class="sexo-btn-group">
                      <button
                        type="button"
                        class="sexo-btn"
                        :class="{
                          'sexo-btn-active': ocorrencia.sexo_vitima === 'M'
                        }"
                        @click="ocorrencia.sexo_vitima = 'M'"
                      >
                        <i class="bi bi-gender-male"></i> Masculino
                      </button>
                      <button
                        type="button"
                        class="sexo-btn"
                        :class="{
                          'sexo-btn-active': ocorrencia.sexo_vitima === 'F'
                        }"
                        @click="ocorrencia.sexo_vitima = 'F'"
                      >
                        <i class="bi bi-gender-female"></i> Feminino
                      </button>
                    </div>
                  </div>

                  <div class="col-12 mb-2">
                    <div class="float-label-group">
                      <input
                        type="text"
                        class="form-control float-label-input"
                        v-model="paciente.telefone"
                        v-mask="'(99) 99999-9999'"
                        disabled
                        placeholder=" "
                      />
                      <label>Seu telefone de contato</label>
                    </div>
                  </div>
                </template>
              </div>

              <div class="row mt-1">
                <div class="col-6 pr-1">
                  <button class="wizard-back-btn" @click="currentStep = 1">
                    <i class="bi bi-arrow-left"></i> Voltar
                  </button>
                </div>
                <div class="col-6 pl-1">
                  <button
                    class="btnn"
                    style="margin:0"
                    @click="currentStep = 3"
                  >
                    Próximo <i class="bi bi-arrow-right"></i>
                  </button>
                </div>
              </div>
            </div>

            <!-- ======== ETAPA 3: Ocorrência ======== -->
            <div v-show="currentStep === 3">
              <div class="row">
                <div class="col-12 mt-1">
                  <h5>
                    {{
                      typePerson == 1
                        ? "Descreva o que você está sentindo"
                        : "Descreva o que aconteceu"
                    }}
                  </h5>
                  <textarea
                    class="form-control mb-3"
                    style="min-height: 20vh"
                    v-model="ocorrencia.queixa_principal"
                    @input="sanitizeQueixa"
                    :placeholder="
                      typePerson == 1
                        ? 'Ex: Dor no peito, dificuldade para respirar...'
                        : 'Ex: Pessoa caiu e está inconsciente...'
                    "
                  ></textarea>
                </div>
              </div>
              <div class="row mt-2">
                <div class="col-6 pr-1">
                  <button class="wizard-back-btn" @click="currentStep = 2">
                    <i class="bi bi-arrow-left"></i> Voltar
                  </button>
                </div>
                <div class="col-6 pl-1">
                  <button
                    class="btnn"
                    style="margin:0"
                    @click="verificaCidadeAtendimento()"
                  >
                    SOLICITAR
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <a href="tel:192">
        <button
          class="btnn"
          style="
            background: #cc4444 !important;
            font-size: 7vw;
            margin: 4vh 0 0 0;
            height: 65vh;
            display: none;
          "
          id="discar"
        >
          O APP não atende este município, por favor disque 192
        </button>
      </a>
    </div>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";
import vSelect from "vue-select";
import GmapMap from "vue2-google-maps";
import moment from "moment";
export default {
  data() {
    return {
      estado_selecionado: null,
      cidade_selecionada: null,
      usr_id: {
        usuario_id: ""
      },
      consent: {
        status: true,
        consent_at: ""
      },
      backgroundImages: [
        "login-samu-01.png",
        "login-samu-02.png",
        "login-samu-03.png",
        "login-samu-04.png",
        "login-samu-05.png"
      ],
      currentBackgroundIndex: 0,
      nao_identificado: false,
      mapLoaded: true,
      verificaCidade: false,
      position: {
        lat: 0,
        lng: 0
      },
      personSelected: false,
      currentStep: 1,
      typePerson: "",
      addressConfirmed: false,
      autocompleteKey: 0,
      usingGPS: true,
      ocorrencia: {
        latitude: 0,
        longitude: 0,
        logradouro: "",
        estado: 0,
        cidade: 0,
        logradouro: "",
        numero: "",
        queixa_principal: "",
        ip_solicitante: "",
        usuario_solicitante_id: 0,
        status: 0,
        data_nascimento_vitima: "",
        sexo_vitima: "",
        telefone: ""
      },
      isTelEditable: false,
      isDisabled: true,
      isLoading: false,
      loadingColor: "#5D9CEC",
      user: {
        usuario_id: "",
        usuario_nome: "",
        telefone: ""
      },
      cor: {
        eu: "rgb(21, 72, 138)",
        outro: "rgb(21, 72, 138)",
        gps: "rgb(21, 72, 138)",
        mapa: "rgb(21, 72, 138)",
        fav: "rgb(21, 72, 138)"
      },
      cidades: [],
      estados: [],
      favoritos: [],
      paciente: {},
      favorito_selecionado: {},
      locationError: false,
      latLngLookupTimeout: null,
      municipioLookupRequestId: 0
    };
  },
  watch: {
    nao_identificado(newValue) {
      if (newValue) {
        this.ocorrencia.nome_vitima = "";
        this.ocorrencia.data_nascimento_vitima = "";
        this.ocorrencia.telefone = "";
        this.ocorrencia.sexo_vitima = "";
        this.ocorrencia.queixa_principal = "";
      } else {
        this.ocorrencia.idade_vitima = "";
      }
    }
  },
  computed: {
    backgroundStyle() {
      const imagePath = require(`@/assets/images/${
        this.backgroundImages[this.currentBackgroundIndex]
      }`);
      return {
        backgroundImage: `url(${imagePath})`,
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center"
      };
    },
    diffIdade() {
      const self = this;

      var a = moment();
      var b = moment(self.ocorrencia.data_nascimento_vitima);

      var years = a.diff(b, "year");
      b.add(years, "years");

      var months = a.diff(b, "months");
      b.add(months, "months");

      var days = a.diff(b, "days");

      if (years < 500) {
        return years + " anos, " + months + " meses, " + days + " dias";
      }
    }
  },
  created() {
    this.currentBackgroundIndex = Math.floor(
      Math.random() * this.backgroundImages.length
    );
  },
  beforeDestroy() {
    if (this.latLngLookupTimeout) {
      clearTimeout(this.latLngLookupTimeout);
    }
  },
  methods: {
    onCepInput() {
      const cep = (this.ocorrencia.cep || "").replace(/[^0-9]/g, "");

      if (cep.length < 8) {
        if (this.latLngLookupTimeout) {
          clearTimeout(this.latLngLookupTimeout);
          this.latLngLookupTimeout = null;
        }

        this.municipioLookupRequestId += 1;

        this.ocorrencia.logradouro = "";
        this.ocorrencia.bairro = "";
        this.ocorrencia.cidade = null;
        this.ocorrencia.estado = null;
        this.ocorrencia.uf = null;
        this.cidade_selecionada = null;
        this.estado_selecionado = null;
      }
    },
    onLogradouroInput() {
      const logradouro = (this.ocorrencia.logradouro || "").trim();

      if (!logradouro) {
        if (this.latLngLookupTimeout) {
          clearTimeout(this.latLngLookupTimeout);
          this.latLngLookupTimeout = null;
        }

        // Invalida respostas assíncronas antigas de busca de município.
        this.municipioLookupRequestId += 1;

        this.ocorrencia.cidade = null;
        this.ocorrencia.estado = null;
        this.ocorrencia.uf = null;
        this.cidade_selecionada = null;
        this.estado_selecionado = null;
        return;
      }

      this.scheduleLatLngLookup();
    },
    onEstadoChange() {
      // Reset cidade when estado changes
      this.cidade_selecionada = null;
      this.cidades = [];
      this.ocorrencia.cidade = null;

      if (this.estado_selecionado) {
        this.ocorrencia.estado = this.estado_selecionado.uf_id;
        this.ocorrencia.uf = this.estado_selecionado.uf_sigla;
        this.getCidades();
        this.scheduleLatLngLookup();
      } else {
        this.ocorrencia.estado = null;
        this.ocorrencia.uf = null;
      }
    },
    onCidadeChange() {
      if (this.cidade_selecionada) {
        this.ocorrencia.cidade = this.cidade_selecionada.municipio_nome;
        this.scheduleLatLngLookup();
      } else {
        this.ocorrencia.cidade = null;
      }
    },
    setCidadeEstadoOcorrencia() {
      this.ocorrencia.cidade = this.cidade_selecionada
        ? this.cidade_selecionada.municipio_nome
        : null;
      this.ocorrencia.uf = this.estado_selecionado
        ? this.estado_selecionado.uf_sigla
        : null;
      this.ocorrencia.estado = this.estado_selecionado
        ? this.estado_selecionado.uf_id
        : null;
    },
    validarIdade(event) {
      let value = event.target.value;

      // Remove qualquer caractere que não seja número
      value = value.replace(/[^0-9]/g, "");

      // Limita a 3 caracteres
      if (value.length > 3) {
        value = value.slice(0, 3);
      }

      // Atualiza o valor
      this.ocorrencia.idade_vitima = value;
    },
    sanitizeQueixa(event) {
      // Remove emojis e símbolos, mantém letras (incluindo acentuadas), números, espaços e pontuação comum
      const sanitized = event.target.value
        .replace(
          /[\u{1F600}-\u{1F64F}\u{1F300}-\u{1F5FF}\u{1F680}-\u{1F6FF}\u{1F1E0}-\u{1F1FF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}\u{FE00}-\u{FEFE}\u{FE0F}\u{1F900}-\u{1F9FF}\u{1FA00}-\u{1FAFF}]/gu,
          ""
        )
        .replace(/[^a-zA-ZÀ-ÿ0-9\s.,!?;:()\-\/'"\n]/g, "");
      if (sanitized !== event.target.value) {
        this.ocorrencia.queixa_principal = sanitized;
        event.target.value = sanitized;
      }
    },
    buscarCPF: function() {
      var self = this;

      self.naoLocalizado = false;

      self.isLoading = true;

      var cpf = self.$store.state.user.cpf.replace(/\.|\-/g, "");

      $.getJSON(
        "https://sigap.it4d.com.br/index.php/pesquisaCpfSus?cpf=" + cpf,
        function(data) {
          if (data.erro === "CPF não encontrado") {
            self.naoLocalizado = true;
            self.isLoading = false;
            console.log("Erro: CPF não encontrado");
            return;
          }
          self.ocorrencia.data_nascimento_vitima = data.dataNascimento.split(
            "T"
          )[0];
          self.ocorrencia.sexo_vitima = data.sexo;

          self.isLoading = false;
        }
      );
    },

    editTel() {
      this.isTelEditable = !this.isTelEditable; // Alterna entre habilitado/desabilitado
    },
    getOcorrencias(id) {
      const self = this;
      // self.isLoading = true;

      this.usr_id.usuario_id = Number(id);
      const api =
        self.$store.state.api + "usuario-ocorrencias?orderByDesc=createdAt";

      axios
        .post(api, this.usr_id)
        .then(response => {
          self.user = self.$store.state.user;
          console.log("aqui", self.user);
          self.ocorrencias = response.data;
          if (
            self.ocorrencias[0].data_fim_atendimento == null &&
            self.ocorrencias[0].data_cancelamento == null
          ) {
            this.$router.push(
              "/visualizar-atendimento/" + self.ocorrencias[0].ocorrencia_id
            );
          }
          self.isLoading = false;
        })
        .catch(error => {
          self.$message(null, error.response.data, "error");
          self.isLoading = false;
        })
        .finally(() => {
          self.isLoading = false;
        });
    },
    setConsent(status) {
      const self = this;
      if (status) {
        self.consent.status = true;
        self.ocorrencia.consent_at = moment().format("YYYY-MM-DD H:m:s");
        self.ocorrencia.consent = 1;
      } else {
        self.consent.status = false;
        swal(
          "Atenção",
          "Para solicitar atendimento, é preciso estar de acordo com os termos e condições da plataforma.",
          "info"
        );
        self.$router.push("/");
      }
    },
    changeBackgroundImage() {
      setInterval(() => {
        this.currentBackgroundIndex =
          (this.currentBackgroundIndex + 1) % this.backgroundImages.length;
      }, 5000);
    },
    onPlaceChanged(place) {
      if (!place || !place.geometry) return;

      const components = place.address_components || [];
      const lat = place.geometry.location.lat();
      const lng = place.geometry.location.lng();

      this.applyAddressComponents(
        components,
        lat,
        lng,
        place.formatted_address
      );
    },
    applyAddressComponents(components, lat, lng, formattedAddress) {
      const get = (type, useShort = false) => {
        const c = components.find(c => c.types.includes(type));
        return c ? (useShort ? c.short_name : c.long_name) : "";
      };

      this.ocorrencia.numero = get("street_number");
      this.ocorrencia.logradouro = get("route");
      this.ocorrencia.bairro =
        get("sublocality_level_1") || get("sublocality") || get("neighborhood");
      this.ocorrencia.cidade = get("administrative_area_level_2");
      this.ocorrencia.uf = get("administrative_area_level_1", true);
      this.ocorrencia.cep = (get("postal_code") || "").replace(/[^0-9]/g, "");

      this.ocorrencia.latitude = lat;
      this.ocorrencia.longitude = lng;
      this.position.lat = lat;
      this.position.lng = lng;
      this.mapLoaded = true;
      this.addressConfirmed = true;

      // Se o CEP não veio nos componentes, busca especificamente por postal_code
      if (!this.ocorrencia.cep && lat && lng) {
        this.fetchCepByLatLng(lat, lng);
      }

      // Resolve IDs de estado/cidade para compatibilidade com o backend
      if (this.ocorrencia.uf) {
        this.getUFId(this.ocorrencia.uf).then(ufId => {
          if (this.ocorrencia.cidade && ufId) {
            this.getMunicipioId(
              this.normalizeText(this.ocorrencia.cidade),
              ufId
            );
          }
        });
      }
    },
    fetchCepByLatLng(lat, lng) {
      const self = this;
      const geocoder = new google.maps.Geocoder();
      geocoder
        .geocode({
          location: { lat: parseFloat(lat), lng: parseFloat(lng) },
          result_type: ["postal_code"]
        })
        .then(response => {
          if (response.results && response.results[0]) {
            const postalComp = response.results[0].address_components.find(c =>
              c.types.includes("postal_code")
            );
            if (postalComp) {
              self.ocorrencia.cep = postalComp.long_name.replace(/[^0-9]/g, "");
            }
          }
        })
        .catch(() => {});
    },
    clearAddress() {
      this.addressConfirmed = false;
      this.autocompleteKey++;
      this.ocorrencia.logradouro = "";
      this.ocorrencia.bairro = "";
      this.ocorrencia.cidade = null;
      this.ocorrencia.uf = null;
      this.ocorrencia.cep = "";
      this.ocorrencia.numero = "";
      this.ocorrencia.complemento = "";
      this.ocorrencia.latitude = 0;
      this.ocorrencia.longitude = 0;
      this.mapLoaded = false;
      this.estado_selecionado = null;
      this.cidade_selecionada = null;
      if (this.latLngLookupTimeout) {
        clearTimeout(this.latLngLookupTimeout);
        this.latLngLookupTimeout = null;
      }
    },
    async myAddress() {
      const self = this;

      self.ocorrencia.logradouro = self.paciente.endereco;
      self.ocorrencia.bairro = self.paciente.bairro;
      self.ocorrencia.cidade = self.paciente.nome_municipio;
      self.ocorrencia.uf = self.paciente.nome_estado;
      self.ocorrencia.numero = self.paciente.numero;
      self.ocorrencia.cep = self.paciente.cep;
      self.ocorrencia.telefone = self.paciente.telefone;
      self.ocorrencia.complemento = self.paciente.complemento;
      self.addressConfirmed = true;

      const ufId = await self.getUFId(self.paciente.nome_estado);
      self.getMunicipioId(self.paciente.nome_municipio, ufId);

      self.scheduleLatLngLookup({ immediate: true });
    },
    selectFavorito() {
      const self = this;
      console.log(self.favorito_selecionado);

      self.ocorrencia.paciente_id = self.favorito_selecionado.paciente_id;
      self.ocorrencia.logradouro = self.favorito_selecionado.endereco;
      self.ocorrencia.bairro = self.favorito_selecionado.bairro;
      self.ocorrencia.cidade = self.favorito_selecionado.nome_municipio;
      self.ocorrencia.uf = self.favorito_selecionado.nome_estado;
      self.ocorrencia.numero = self.favorito_selecionado.numero;
      self.ocorrencia.cep = self.favorito_selecionado.cep;

      self.scheduleLatLngLookup({ immediate: true });
    },
    async buscar() {
      const self = this;

      if (!self.ocorrencia.cep || self.ocorrencia.cep.slice(-1) === "_") {
        return;
      }

      if (!/^[0-9]{5}-[0-9]{3}$/.test(self.ocorrencia.cep)) {
        return;
      }

      self.naoLocalizado = false;
      self.usingGPS = false;

      try {
        const endereco = await $.getJSON(
          "https://viacep.com.br/ws/" + self.ocorrencia.cep + "/json/"
        );

        if (endereco.erro) {
          self.endereco = {};
          self.naoLocalizado = true;
          self.$nextTick(() => {
            document.getElementById("inputNumero") &&
              document.getElementById("inputNumero").focus();
          });
          return;
        }

        self.endereco = endereco;
        self.ocorrencia.logradouro = endereco.logradouro;
        self.ocorrencia.bairro = endereco.bairro;
        self.ocorrencia.cidade = endereco.localidade;
        self.ocorrencia.uf = endereco.uf;

        // Load UF first so getCidades() and getMunicipioByIbge() have estado_selecionado
        await self.getUFId(endereco.uf);

        // Load cidades and lookup municipio by IBGE in parallel
        await Promise.all([
          self.getCidades(),
          self.getMunicipioByIbge(endereco.ibge.slice(0, -1))
        ]);

        self.$nextTick(() => {
          document.getElementById("inputNumero") &&
            document.getElementById("inputNumero").focus();
        });

        self.scheduleLatLngLookup({ immediate: true });
      } catch (error) {
        console.error("Erro ao buscar CEP:", error);
        self.naoLocalizado = true;
      }
    },
    scheduleLatLngLookup(options = {}) {
      const { immediate = false } = options;

      if (this.latLngLookupTimeout) {
        clearTimeout(this.latLngLookupTimeout);
        this.latLngLookupTimeout = null;
      }

      if (immediate) {
        this.getLatLngGoogle();
        return;
      }

      this.latLngLookupTimeout = setTimeout(() => {
        this.getLatLngGoogle();
        this.latLngLookupTimeout = null;
      }, 500);
    },
    sanitizeNumero(event) {
      const raw = event.target.value || "";
      this.ocorrencia.numero = raw.replace(/[^a-zA-Z0-9]/g, "").slice(0, 10);
    },
    getLatLngGoogle() {
      const self = this;

      self.mapLoaded = false;

      const nomeEstado = self.estado_selecionado
        ? self.estado_selecionado.uf_nome
        : self.ocorrencia.uf || "";

      const nomeCidade = self.cidade_selecionada
        ? self.cidade_selecionada.municipio_nome
        : self.ocorrencia.cidade;

      if (!nomeCidade) {
        return;
      }

      let endereco =
        (self.ocorrencia.numero || "") +
        " " +
        (self.ocorrencia.logradouro || "") +
        ", " +
        nomeCidade +
        ", " +
        nomeEstado +
        ", Brazil";

      let url =
        "https://maps.googleapis.com/maps/api/geocode/json?address=" +
        encodeURIComponent(endereco) +
        "&key=AIzaSyBmngiC-7NbxzKxUzwCE0NfKzWNSDxr9zc";

      $.getJSON(url, function(response) {
        if (!response.results || response.results.length === 0) {
          console.log("Endereço não encontrado");
          return;
        }

        let result = response.results[0];
        let location = result.geometry.location;

        self.ocorrencia.latitude = Number(location.lat);
        self.ocorrencia.longitude = Number(location.lng);

        self.position.lat = Number(location.lat);
        self.position.lng = Number(location.lng);

        // Aproveita o retorno para preencher o CEP se ainda estiver vazio
        if (!self.ocorrencia.cep && result.address_components) {
          const postalComp = result.address_components.find(c =>
            c.types.includes("postal_code")
          );
          if (postalComp) {
            self.ocorrencia.cep = postalComp.long_name.replace(/[^0-9]/g, "");
          }
        }

        self.mapLoaded = true;
      });
    },
    atendimento(id) {
      const self = this;

      self.personSelected = true;
      self.currentStep = 1;

      if (id) {
        self.user.usuario_id = self.$store.state.user.usuario_id;
        self.user.usuario_nome = self.$store.state.user.usuario_nome;
        self.user.telefone = self.$store.state.user.telefone;
        self.ocorrencia.nome_vitima = self.$store.state.user.usuario_nome;
        self.ocorrencia.data_nascimento_vitima = self.paciente.data_nascimento;
        self.ocorrencia.sexo_vitima = self.paciente.sexo;
        self.ocorrencia.telefone = self.$store.state.user.telefone;
        self.ocorrencia.paciente_id = self.$store.state.user.paciente_id;
        self.typePerson = 1;
      } else {
        self.user.usuario_id = self.$store.state.user.usuario_id;
        self.user.usuario_nome = self.$store.state.user.usuario_nome;
        self.user.telefone = self.$store.state.user.telefone;
        self.typePerson = 2;
      }
    },
    getEstados() {
      const self = this;
      self.isLoading = true;

      const api =
        self.$store.state.api + "ufs?paginated=false&orderByAsc=uf_nome";

      axios
        .get(api, this.usuario_id)
        .then(response => {
          self.estados = response.data.data;
          self.isLoading = false;
          setTimeout(function() {
            self.getPacientes();
          }, 500);
        })
        .catch(error => {
          self.isLoading = false;
        });
    },
    getCidades() {
      const self = this;
      self.isLoading = true;

      const api =
        self.$store.state.api +
        "municipios?paginated=false&orderByAsc=municipio_nome&uf_id=" +
        self.estado_selecionado.uf_id;

      return axios
        .get(api, this.usuario_id)
        .then(response => {
          self.cidades = response.data.data;
          self.isLoading = false;
        })
        .catch(error => {
          self.isLoading = false;
        });
    },
    getUFId(uf) {
      const self = this;
      const api = self.$store.state.api + "ufs?uf_nome=" + uf;

      return axios
        .get(api, this.usuario_id)
        .then(response => {
          const estado = response.data.data[0];
          self.ocorrencia.estado = estado.uf_id;
          self.estado_selecionado = estado;
          return estado.uf_id;
        })
        .catch(error => {
          self.isLoading = false;
          return null;
        });
    },
    normalizeText(value) {
      if (!value) {
        return "";
      }

      return value
        .toString()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toUpperCase()
        .trim();
    },
    waitForEstadoSelecionado(
      expectedUfId = null,
      maxWaitMs = 2000,
      intervalMs = 100
    ) {
      return new Promise((resolve, reject) => {
        const start = Date.now();

        const check = () => {
          const estado = this.estado_selecionado;
          const ufId = estado && (estado.uf_id || estado.id);
          const isExpected =
            expectedUfId == null || Number(ufId) === Number(expectedUfId);

          if (ufId && isExpected) {
            resolve(ufId);
            return;
          }

          if (Date.now() - start >= maxWaitMs) {
            reject(new Error("estado_selecionado não preenchido a tempo"));
            return;
          }

          setTimeout(check, intervalMs);
        };

        check();
      });
    },

    getMunicipioByIbge(ibge) {
      const self = this;
      const api = self.$store.state.api + "municipios?municipio_codigo=" + ibge;

      return axios
        .get(api, this.usuario_id)
        .then(response => {
          self.cidade_selecionada = response.data.data[0];
          if (self.cidade_selecionada) {
            self.ocorrencia.cidade = self.cidade_selecionada.municipio_nome;
          }
        })
        .catch(error => {
          self.isLoading = false;
        });
    },
    async getMunicipioId(nome, ufIdParam = null) {
      const self = this;
      const nomeNormalizado = self.normalizeText(nome);
      let ufId = ufIdParam;

      if (!ufId) {
        try {
          ufId = await self.waitForEstadoSelecionado();
        } catch (error) {
          console.warn(
            "Não foi possível obter uf_id para buscar município",
            error
          );
          return;
        }
      }

      self.municipioLookupRequestId += 1;
      const currentRequestId = self.municipioLookupRequestId;

      const api =
        self.$store.state.api +
        "municipios?municipio_nome=" +
        encodeURIComponent(nomeNormalizado) +
        "&uf_id=" +
        ufId;

      axios
        .get(api, this.usuario_id)
        .then(response => {
          if (currentRequestId !== self.municipioLookupRequestId) {
            return;
          }

          self.cidade_selecionada = response.data.data[0];
        })
        .catch(error => {
          self.isLoading = false;
        });
    },
    getPacientes() {
      const self = this;
      self.isLoading = true;

      const api =
        self.$store.state.api +
        "paciente?paciente_id=" +
        self.$store.state.user.paciente_id;
      axios
        .get(api, this.usuario_id)
        .then(response => {
          self.paciente = response.data.data[0];
          self.isLoading = false;
        })
        .catch(error => {
          self.isLoading = false;
        });
    },

    localizacao(id) {
      const self = this;

      switch (id) {
        case 0:
          self.cor.gps = "rgb(21, 72, 138)";
          self.cor.mapa = "#bbb";
          self.cor.fav = "#bbb";
          $("#geo-form").show();
          $("#favoritos").hide();
          $("#mapa").show();
          break;
        case 1:
          self.cor.gps = "#bbb";
          self.cor.mapa = "rgb(21, 72, 138)";
          self.cor.fav = "#bbb";
          $("#geo-form").show();
          $("#favoritos").hide();
          $("#mapa").show();
          break;
        case 2:
          self.cor.gps = "#bbb";
          self.cor.mapa = "#bbb";
          self.cor.fav = "rgb(21, 72, 138)";
          $("#geo-form").show();
          $("#favoritos").show();
          $("#mapa").show();
          break;
      }
    },

    criarOcorrencia() {
      const self = this;
      self.isLoading = true;
      let api = self.$store.state.api + "ocorrencia";

      if (
        self.ocorrencia.data_nascimento_vitima != "" &&
        !self.nao_identificado
      ) {
        self.ocorrencia.idade_vitima = self.diffIdade;
      }
      console.log("chegou na criaçãooo");

      console.log("chegou na criaçãoodassado", self.ocorrencia);

      console.log("telefone", self.nao_identificado);

      if (self.nao_identificado == true) {
        self.ocorrencia.telefone = self.paciente.telefone;
      }

      self.ocorrencia.tipo_pessoa = self.typePerson;

      axios
        .post(api, {
          ...self.ocorrencia,
          user: self.user,
          nao_identificado: self.nao_identificado
        })
        .then(response => {
          if (response.data.original.chamar) {
            self.$message(null, response.data.original.text, "error");
            $("#card-geral").hide();
            $("#discar").show();
          } else {
            swal("Sucesso", "Seu atendimento foi registrado.", "success");
            // window.location.href = "tel:" + 192;
            this.$router.push(
              "/visualizar-atendimento/" + response.data.original.ocorrencia_id
            );
          }
          self.isLoading = false;
        })
        .catch(error => {
          self.isLoading = false;
          self.$message(null, error.response.data, "error");
        });
    },
    getIPAddress() {
      const self = this;
      return fetch("https://api.ipify.org?format=json")
        .then(response => response.json())
        .then(data => {
          self.ocorrencia.ip_solicitante = data.ip; // Returns the IP address object
        });
    },
    getGeo() {
      const self = this;
      self.isLoading = true;

      if ("geolocation" in navigator) {
        navigator.geolocation.getCurrentPosition(
          position => {
            self.ocorrencia.latitude = position.coords.latitude;
            self.ocorrencia.longitude = position.coords.longitude;
            self.ocorrencia.complemento = null;
            self.position.lat = position.coords.latitude;
            self.position.lng = position.coords.longitude;

            self.mapLoaded = true;

            self.geocodeLatLng(
              position.coords.latitude,
              position.coords.longitude
            );
          },
          error => {
            console.log("Erro ao obter geolocalização:", error);
            self.isLoading = false;
          }
        );

        $("#mapa").show();
      } else {
        console.log("Geolocalização não é suportada pelo seu navegador");
        self.isLoading = false;
      }

      self.isLoading = false;
    },
    geocodeLatLng(lat, lng) {
      const self = this;
      self.isLoading = true;
      const geocoder = new google.maps.Geocoder();

      geocoder
        .geocode({ location: { lat: parseFloat(lat), lng: parseFloat(lng) } })
        .then(response => {
          if (response.results[0]) {
            self.applyAddressComponents(
              response.results[0].address_components,
              lat,
              lng,
              response.results[0].formatted_address
            );
          }
          self.isLoading = false;
        })
        .catch(() => {
          self.isLoading = false;
        });
    },
    discar192() {
      window.location.href = "tel:" + 192;
    },
    verificaCidadeAtendimento() {
      const self = this;

      var cidade = self.ocorrencia.cidade;

      if (!cidade) {
        swal(
          "Atenção",
          "Por favor, informe a cidade da ocorrência.",
          "warning"
        );
        return;
      }

      self.isLoading = true;
      let api = self.$store.state.api + "verifica-cidade";

      axios
        .post(api, { cidade: cidade })
        .then(response => {
          console.log(response);
          if (response.data == false) {
            swal({
              title: "Você está fora da nossa área de cobertura!",
              text: "Deseja discar para o 192 da sua região?",
              type: "warning",
              showCancelButton: true,
              confirmButtonColor: "#DD6B55",
              confirmButtonText: "Sim, deletar!",
              showLoaderOnConfirm: true,
              buttons: {
                catch: {
                  text: "Não",
                  value: "cancel",
                  className: "btn btn-danger"
                },
                confirm: {
                  text: "Sim",
                  value: "confirm",
                  className: "btn btn-success"
                }
              }
            }).then(value => {
              switch (value) {
                case "cancel":
                  swal(
                    "Atenção",
                    "Para chamar o SAMU através deste App, você deverá informar um endereço que esteja dentro da nossa área de atendimento.",
                    "info"
                  );
                  break;

                case "confirm":
                  window.location.href = "tel:" + 192;
                  break;
              }
            });
          } else {
            self.criarOcorrencia();
          }
          self.isLoading = false;
        })
        .catch(error => {
          self.isLoading = false;
          self.$message(null, error.response.data, "error");
        });
    },
    checkLocation() {
      if (!navigator.geolocation) {
        this.locationError = true; // Ativar a mensagem de erro
        this.errorMessage = "Seu navegador não suporta geolocalização.";
      } else {
        navigator.geolocation.getCurrentPosition(
          position => {
            // Localização bem-sucedida
            console.log("Localização obtida:", position);
            this.locationError = false; // Resetar o erro se a localização foi obtida
          },
          error => {
            // Erro ao obter a localização
            console.error("Erro ao obter a localização:", error);
            this.locationError = true; // Ativar a mensagem de erro

            // Verificar o código de erro
            if (error.code === error.PERMISSION_DENIED) {
              this.errorMessage =
                "Acesso à geolocalização foi negado. Por favor, ative a localização nas configurações do seu navegador.";
            } else if (error.code === error.POSITION_UNAVAILABLE) {
              this.errorMessage =
                "Localização não disponível. Tente novamente mais tarde.";
            } else {
              this.errorMessage =
                "Erro ao obter a localização. Tente novamente.";
            }
          }
        );
      }
    }
  },
  components: {
    Loading,
    vSelect
  },
  props: {},
  mounted: function() {
    const self = this;
    self.isLoading = true;

    self.getEstados();

    $("#menu-main").removeClass("show");
    $(".offcanvas-backdrop.show").removeClass("show");
    /* $(".theme-light").removeAttribute("style","overflow: hidden; padding-right: 0px;"); */
    // document.body.setAttribute("style", null);

    var id = localStorage.getItem("usuario_id");

    self.getOcorrencias(id);

    self
      .getIPAddress()
      .then(ipAddress => {
        this.ocorrencia.ip = ipAddress; // Print the user's IP address
      })
      .catch(error => {
        console.error("Error:", error);
      });

    this.checkLocation();

    // self.getGeo();
  }
};
</script>
<style scoped>
/* LOADING */
.custom-loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(5px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.custom-loading-spinner {
  width: 100px;
  height: 100px;
  z-index: 10000;
}

/* CARD PRINCIPAL */
.card-style {
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
  border: none !important;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
  border-radius: 16px !important;
  margin-bottom: 20px;
}

.card-body {
  padding: 24px !important;
}

/* TÍTULOS E TEXTOS */
.card-title {
  font-size: 32px;
  font-weight: bold;
  color: #d6582c;
  margin-bottom: 20px !important;
  letter-spacing: -0.5px;
}

h5 {
  font-weight: 600;
  color: #1f2937;
  font-size: 15px;
  margin-top: 16px;
  margin-bottom: 10px;
}

/* INPUTS E SELECTS */
.form-control,
.vselect {
  border-radius: 8px !important;
  border: 1px solid #e5e7eb !important;
  padding: 12px 14px !important;
  font-size: 15px;
  transition: all 0.3s ease !important;
  background-color: #fff !important;
}

.form-control:focus,
.vselect:focus {
  border-color: #1548a6 !important;
  box-shadow: 0 0 0 3px rgba(21, 72, 166, 0.1) !important;
  outline: none !important;
}

textarea.form-control {
  resize: vertical;
  font-family: inherit;
  min-height: 120px;
}

/* BOTÕES PRINCIPAIS */
.btnn {
  width: 100% !important;
  background: linear-gradient(135deg, #cf6b46 0%, #d6582c 100%) !important;
  border: none !important;
  border-radius: 10px !important;
  font-weight: 600 !important;
  font-size: 16px !important;
  padding: 14px 20px !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
  box-shadow: 0 4px 12px rgba(21, 72, 166, 0.3) !important;
  color: white !important;
  cursor: pointer;
  margin: 8px 0;
}

.btnn:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 8px 20px rgba(21, 72, 166, 0.4) !important;
}

.btnn:active {
  transform: translateY(0) !important;
}

/* BOTÕES SECUNDÁRIOS */
.btn-success,
.btn-danger {
  border-radius: 10px !important;
  font-weight: 600 !important;
  padding: 12px 20px !important;
  border: none !important;
  transition: all 0.3s ease !important;
}

.btn-success {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%) !important;
  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3) !important;
}

.btn-success:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 8px 20px rgba(16, 185, 129, 0.4) !important;
}

.btn-danger {
  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%) !important;
  box-shadow: 0 4px 12px rgba(239, 68, 68, 0.3) !important;
}

.btn-danger:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 8px 20px rgba(239, 68, 68, 0.4) !important;
}

.btn-block {
  display: block;
  width: 100% !important;
}

/* BOTÕES LOCALIZAÇÃO */
.btn-gps {
  background: linear-gradient(135deg, #cc6540 0%, #d6582c 100%) !important;
  border: none !important;
  border-radius: 8px !important;
  padding: 10px 8px !important;
  width: 100% !important;
  color: white !important;
  font-size: 12px !important;
  font-weight: 600 !important;
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  transition: all 0.3s ease !important;
  box-shadow: 0 2px 8px rgba(21, 72, 166, 0.2) !important;
  cursor: pointer;
}

.btn-gps:hover:not(:disabled) {
  transform: translateY(-2px) !important;
  box-shadow: 0 4px 12px rgba(21, 72, 166, 0.3) !important;
}

.btn-gps:disabled {
  background: rgba(65, 93, 129, 0.5) !important;
  cursor: not-allowed !important;
  opacity: 0.6;
}

.btn-gps2 {
  background: linear-gradient(135deg, #cc6540 0%, #d6582c 100%) !important;
  border: none !important;
  border-radius: 8px !important;
  padding: 10px 16px !important;
  width: 65% !important;
  color: white !important;
  font-weight: 600 !important;
  transition: all 0.3s ease !important;
}

.btn-gps2:hover {
  transform: translateY(-2px) !important;
}

/* TEXTO DOS TERMOS */
section {
  animation: slideIn 0.3s ease-out;
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

section div {
  line-height: 1.6;
  color: #374151;
  font-size: 14px;
}

/* MAPA */
.vue-map-container .vue-map .gm-style {
  border-radius: 16px !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08) !important;
}

/* PLACES AUTOCOMPLETE */
.places-search-wrapper {
  position: relative;
  margin-top: 4px;
}

.places-search-icon {
  position: absolute;
  left: 14px;
  top: 50%;
  transform: translateY(-50%);
  color: #9ca3af;
  font-size: 16px;
  pointer-events: none;
  z-index: 1;
}

.places-input {
  padding-left: 40px !important;
  font-size: 15px !important;
}

/* força o dropdown do Google a aparecer acima de tudo */
.pac-container {
  z-index: 99999 !important;
  border-radius: 12px !important;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12) !important;
  border: 1px solid #e5e7eb !important;
  font-family: inherit !important;
  margin-top: 4px !important;
}

.pac-item {
  padding: 10px 14px !important;
  font-size: 14px !important;
  cursor: pointer !important;
  border-top: 1px solid #f3f4f6 !important;
}

.pac-item:hover {
  background-color: #f0f4ff !important;
}

.pac-item-query {
  font-size: 14px !important;
  color: #1f2937 !important;
}

/* ENDEREÇO CONFIRMADO */
.address-confirmed-card {
  display: flex;
  align-items: center;
  gap: 10px;
  background: #f0f4ff;
  border: 1px solid #c7d7fa;
  border-radius: 12px;
  padding: 12px 14px;
  margin-top: 4px;
}

.address-confirmed-icon {
  font-size: 22px;
  color: #15488a;
  flex-shrink: 0;
}

.address-confirmed-info {
  flex: 1;
  text-align: left;
}

.address-confirmed-main {
  font-size: 14px;
  font-weight: 600;
  color: #1f2937;
  line-height: 1.3;
}

.address-confirmed-sub {
  font-size: 12px;
  color: #6b7280;
  margin-top: 2px;
}

.address-confirmed-change {
  background: none;
  border: none;
  color: #15488a;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  padding: 4px 6px;
  border-radius: 6px;
  flex-shrink: 0;
  text-decoration: underline;
}

.address-confirmed-change:hover {
  background: rgba(21, 72, 138, 0.08);
}

/* FLOAT LABEL */
.float-label-group {
  position: relative;
}

.float-label-input {
  padding-top: 20px !important;
  padding-bottom: 8px !important;
  height: auto !important;
}

.float-label-group label {
  position: absolute;
  top: 50%;
  left: 14px;
  transform: translateY(-50%);
  font-size: 15px;
  color: #9ca3af;
  font-weight: 400;
  pointer-events: none;
  transition: all 0.18s ease;
  margin: 0;
}

.float-label-input:not(:placeholder-shown) + label,
.float-label-input:focus + label {
  top: 10px;
  transform: translateY(0);
  font-size: 11px;
  color: #15488a;
  font-weight: 600;
}

.float-label-input:disabled + label {
  color: #9ca3af;
}

/* TOGGLE NÃO IDENTIFICADO */
.vitima-unidentified-toggle {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fffbeb;
  border: 1px solid #fde68a;
  border-radius: 10px;
  padding: 10px 14px;
  cursor: pointer;
  user-select: none;
  margin-bottom: 4px;
}

.vitima-unidentified-text {
  font-size: 14px;
  font-weight: 600;
  color: #92400e;
  display: flex;
  align-items: center;
  gap: 7px;
}

/* BADGE IDADE */
.vitima-idade-badge {
  display: inline-block;
  margin-top: 5px;
  font-size: 12px;
  color: #15488a;
  background: #eff6ff;
  border-radius: 20px;
  padding: 2px 10px;
  font-weight: 500;
}

/* SEXO BOTÕES */
.sexo-label {
  font-size: 11px;
  font-weight: 600;
  color: #15488a;
  margin-bottom: 5px;
  padding-left: 2px;
}

.sexo-btn-group {
  display: flex;
  gap: 5px;
}

.sexo-btn {
  flex: 1;
  padding: 13px 8px;
  border-radius: 10px;
  border: 2px solid #e5e7eb;
  background: #fff;
  color: #6b7280;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}

.sexo-btn i {
  font-size: 18px;
}

.sexo-btn:hover:not(:disabled) {
  border-color: #15488a;
  color: #15488a;
  background: #f0f4ff;
}

.sexo-btn-active {
  background: #15488a !important;
  border-color: #15488a !important;
  color: #fff !important;
  box-shadow: 0 2px 8px rgba(21, 72, 138, 0.3);
}

.sexo-disabled .sexo-btn {
  opacity: 0.6;
  cursor: not-allowed;
}

/* WIZARD STEP INDICATOR */
.wizard-header-strip {
  border-bottom: 1px solid #f0f0f0;
}

.wizard-user-name {
  font-weight: 600;
  color: #1f2937;
  font-size: 15px;
}

.wizard-user-phone {
  font-size: 13px;
  color: #6b7280;
}

.wizard-indicator {
  padding: 0 4px;
}

.wizard-step-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 60px;
}

.wizard-step-circle {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #e5e7eb;
  color: #9ca3af;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  transition: all 0.3s ease;
  margin-bottom: 4px;
}

.wizard-step-circle.wizard-step-active {
  background: linear-gradient(135deg, #15488a 0%, #1a56a8 100%);
  color: #fff;
  box-shadow: 0 3px 10px rgba(21, 72, 138, 0.35);
}

.wizard-step-label {
  font-size: 11px;
  color: #9ca3af;
  font-weight: 500;
  white-space: nowrap;
}

.wizard-step-label.wizard-step-label-active {
  color: #15488a;
  font-weight: 700;
}

.wizard-step-line {
  height: 2px;
  background: #e5e7eb;
  margin: 0 4px;
  margin-bottom: 18px;
  transition: background 0.3s ease;
}

.wizard-step-line.wizard-line-done {
  background: linear-gradient(90deg, #15488a, #1a56a8);
}

/* BOTÃO VOLTAR DO WIZARD */
.wizard-back-btn {
  width: 100%;
  background: transparent !important;
  border: 2px solid #d1d5db !important;
  border-radius: 10px !important;
  font-weight: 600 !important;
  font-size: 15px !important;
  padding: 12px 16px !important;
  color: #6b7280 !important;
  cursor: pointer;
  transition: all 0.2s ease;
}

.wizard-back-btn:hover {
  border-color: #9ca3af !important;
  color: #374151 !important;
}

/* INPUTS E OUTROS */
.input-group {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  width: 100%;
}

.input-group > .form-control {
  position: relative;
  flex: 1 1 auto;
  width: 1%;
  margin-bottom: 0;
}

.input-group > .form-control:focus {
  z-index: 3;
}

.custom-input-container {
  position: relative;
}

/* RESPONSIVIDADE */
@media (max-width: 768px) {
  .card-body {
    padding: 18px !important;
  }

  .card-title {
    font-size: 20px;
  }

  h5 {
    font-size: 14px;
    margin-top: 14px;
  }

  .form-control {
    font-size: 14px !important;
  }

  .btnn {
    font-size: 15px !important;
    padding: 12px 16px !important;
  }
}

@media (max-width: 480px) {
  .card-body {
    padding: 14px !important;
  }

  .card-title {
    font-size: 18px;
  }

  h5 {
    font-size: 13px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SolicitarAtendimento.vue